(function($){
    if($('.shop_table.order_details, .woocommerce-thankyou-order-details').length > 0){
        $('.woocommerce-table__product-name').each(function(){
            if($(this).text().indexOf('Voucher') > -1){
                $(this).find('a > strong').html('Pobierz Voucher PDF');
            }
            else{
                $(this).find('a > strong').html('Pobierz Bilet PDF');
            }
        })
    }
})(jQuery)